// import { Loadable } from '../../index.j';


export const getAutoPlayPreference = ({ preferences }) =>
    preferences.autoPlay;
